module.exports = __webpack_public_path__ + "media/styles/images/png/circle-left-arrow-gray-dark-f74de9bd19cff2999545063653e2add5.png";